import { END_POINT } from "../../constants/api.constants";
import {store} from "../../store";

const {
  INVENTORY_SEARCH,
} = END_POINT;

export const getInventorySearchAPi = async (payload ) => {
  // console.log({ token: store.getState().app.token });
  return await fetch(
    `${INVENTORY_SEARCH}`, 
    {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return {
        status: data.status,
        message: data.message,
        data: data.data,
      };
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};